import { enqueueSnackbar, useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { DatePicker } from "@mui/x-date-pickers-pro";
import { TextField } from "@mui/material";
import dayjs from "dayjs";

type Props = {
	params: any;
	dateFormat: string;
	compareField: string; // 'ToDt' ή 'FromDt'
	direction?: "before" | "after"; // προεπιλογή = 'before'
	errorMessage: string;
};

const ValidatedDateEditCell = ({
								   params,
								   dateFormat,
								   compareField,
								   direction = "before",
								   errorMessage,
							   }: Props) => {
	const { enqueueSnackbar } = useSnackbar(); // Καλέστε το hook για το snackbar
	
	const currentValue = dayjs(params.value);
	const compareValue = dayjs(params.row[compareField]);
	
	const shouldValidate = params.field === "ToDt"; //Για να περνάει τον έλεγχο μόνο όταν επεξεργαζόμαστε το Ημερ/νία έως καθως δεν μας αφηνε να αλλάξουμε το ημ/νια από
	// Ελέγχουμε αν η ημερομηνία είναι έγκυρη
	const isInvalid =
		shouldValidate &&  //Για να περνάει τον έλεγχο μόνο όταν επεξεργαζόμαστε το Ημερ/νία έως
		currentValue.isValid() &&
		compareValue.isValid() &&
		((direction === "before" && currentValue.isAfter(compareValue)) ||
			(direction === "after" && currentValue.isBefore(compareValue)));
	
	// Αν η ημερομηνία είναι άκυρη, εμφανίζουμε μήνυμα και σβήνουμε την τιμή
	const handleChange = (newValue) => {
		if (
			shouldValidate &&  //Για να περνάει τον έλεγχο μόνο όταν επεξεργαζόμαστε το Ημερ/νία έως
			newValue &&
			compareValue.isValid() &&
			((direction === "before" && newValue.isAfter(compareValue)) ||
				(direction === "after" && newValue.isBefore(compareValue)))
		) {
			params.api.setEditCellValue({
				id: params.id,
				field: params.field,
				value: null,
			});
			// Εμφανίζουμε το μήνυμα σφάλματος με το enqueueSnackbar
			enqueueSnackbar(errorMessage, { variant: "error", autoHideDuration: 3000, });
		} else {
			params.api.setEditCellValue({
				id: params.id,
				field: params.field,
				value: newValue?.toDate(),
			});
		}
	};
	
	return (
		<DatePicker
			value={currentValue}
			format={dateFormat}
			onChange={handleChange}
			slotProps={{
				textField: {
					fullWidth: true,
					size: "small",
					error: isInvalid,
					helperText: isInvalid ? errorMessage : " ",
					margin: "normal",
					style: {
						marginTop: "30px", // Μεγαλύτερο περιθώριο από κάτω
					},
				},
			}}
		/>
	);
};

export default ValidatedDateEditCell;
